import * as React from 'react'
import { Form } from 'formik'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { MultiSelect } from '@workwave-tidal/core/components'
import type { AssigneeOption, ISalesTeam } from '@user/store/salesTeam'
import {
  useBacksideData,
  useBacksideHandlers,
  useOnBacksideMount,
} from '../../hooks'
import { SalesTeamMultiselect } from '@user/components/SalesTeam/SalesTeamMultiselect/SalesTeamMultiselect'

type Props = {
  assigneeIds: string[]
  salesTeams: ISalesTeam[]
  initData: { salesTeamIds: number[]; assigneeIds: string[] }
  testIdPrefix?: string
}

export function SettingsForm(props: Props) {
  const { assigneeIdsValue, owners } = useBacksideData()
  const { renderSummary, handleSelectOwnerId, isOptionEqual, getId } =
    useBacksideHandlers()

  useOnBacksideMount({ ...props })

  return (
    <Form autoComplete="off">
      <Box paddingBottom={2} position="relative">
        <SalesTeamMultiselect
          leaveOwners
          testIdPrefix={`${props?.testIdPrefix}-sales-team-multiselect`}
        />
      </Box>
      <Box mt={2} paddingBottom={2} position="relative">
        <MultiSelect<AssigneeOption>
          items={owners}
          label="Sales Team Member"
          optionMode="normal"
          inputMode="summary"
          density="normal"
          textFieldProps={{
            //@ts-expect-error pendo requires data-test-id to be on the root element of the component
            ['data-test-id']: `${props?.testIdPrefix}-assignee-multiselect`,
          }}
          hideCheckbox={false}
          value={assigneeIdsValue}
          getLabel={(option) => option.name}
          onChange={handleSelectOwnerId}
          getId={getId}
          autocompleteProps={{
            isOptionEqualToValue: isOptionEqual,
            size: 'small',
          }}
          renderSummary={(options) =>
            renderSummary(options, 'Sales Team Members')
          }
          placeholder="Search more Sales Team Members"
        />
      </Box>

      <Box mt={1} display="flex" justifyContent="flex-end">
        <Button
          color="primary"
          type="submit"
          variant="contained"
          data-test-id={`${props?.testIdPrefix}-save-settings-button`}
        >
          Save Settings
        </Button>
      </Box>
    </Form>
  )
}
